import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    headerLabel: {
        fontSize: '13px',
        fontWeight: 700,
        color: 'red',
    },
}));
